cmsForm2022.prototype.populateImageField = function(imageField,value){
//  imageField.querySelector("button").innerHTML = "<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><title>Cloud Upload</title><path d='M320 367.79h76c55 0 100-29.21 100-83.6s-53-81.47-96-83.6c-8.89-85.06-71-136.8-144-136.8-69 0-113.44 45.79-128 91.2-60 5.7-112 43.88-112 106.4s54 106.4 120 106.4h56' fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='32'/><path fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='32' d='M320 255.79l-64-64-64 64M256 448.21V207.79'/></svg> Change "+imageField.getAttribute("data-label");

  var addImagePreview = (src) => {
    var imagePreview = document.createElement("div");
    imagePreview.classList.add("imagePreview");
    imagePreview.setAttribute("data-image",src);
    var imagePreviewRemove = document.createElement("div");
    imagePreviewRemove.innerHTML = "&times;";
    imagePreviewRemove.classList.add("remove");
    imagePreviewRemove.setAttribute("data-image",src);

    imagePreviewRemove.addEventListener("click",(e)=>{
      e.preventDefault();
      console.log("REMOVE");
      var imageURL = e.currentTarget.getAttribute("data-image");

      var imageInput = e.currentTarget.parentNode.parentNode.parentNode.querySelector("input[type='hidden']");
      var imageValues = imageInput.value.split(",");
      var newValues = imageValues.filter(i=>{
        if(i == imageURL){
          return false;
        }
        return true;
      });

      imageInput.value = newValues.join(",");

      e.target.parentNode.remove();
    });
    imagePreview.append(imagePreviewRemove);


    var imagePreviewIMG = new Image();
    imagePreviewIMG.onload = () => {
      imagePreview.append(imagePreviewIMG);
      imageField.querySelector(".imagePreviewHolder").append(imagePreview);
    };
    imagePreviewIMG.src = src;


  };
  var images = value.split(",");
  images.forEach(i=>{
    addImagePreview(i);
  })

  imageField.querySelector("input[type='hidden']").value = value;

};

cmsForm2022.prototype.imageFields = function(){
  var self = this;
  var imageFields = this.form.getElementsByClassName("imageField");

  for(let i =0;i<imageFields.length;i++){
    var f = imageFields[i];


      f.innerHTML = "";
      var name = f.getAttribute("data-name");
      var label = f.getAttribute("data-label");
      var url = f.getAttribute("data-url");
      var helpText = f.getAttribute("data-help");



      var input = document.createElement("input");
      input.setAttribute("type","hidden");
      input.setAttribute("name",name);


      var imageInput = document.createElement("input");
      imageInput.setAttribute("data-fieldName",name);
      imageInput.setAttribute("type","file");
      imageInput.style.display = "none";
      imageInput.setAttribute("accept",f.getAttribute("data-type") || "image/png,image/jpeg,image/jpg,image/gif,image/webp");
      var imageInputID = "image_"+Math.random(0,999999);
      imageInput.setAttribute("id",imageInputID);
      if(f.getAttribute("data-multiple")){
        imageInput.setAttribute("multiple","multiple");
      }


      document.querySelector("body").append(imageInput);


      imageInput.addEventListener("change",function(e){
        var f = document.querySelector("div[data-name='"+e.currentTarget.getAttribute("data-fieldName")+"']");
        self.uploadImage(e,f);
      });



      var button = document.createElement("button");
      button.setAttribute("data-imageInput",imageInputID);
      button.innerHTML = "<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><title>Cloud Upload</title><path d='M320 367.79h76c55 0 100-29.21 100-83.6s-53-81.47-96-83.6c-8.89-85.06-71-136.8-144-136.8-69 0-113.44 45.79-128 91.2-60 5.7-112 43.88-112 106.4s54 106.4 120 106.4h56' fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='32'/><path fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='32' d='M320 255.79l-64-64-64 64M256 448.21V207.79'/></svg> "+(f.getAttribute("data-button")||"Upload Photo");

      button.addEventListener("click",function(e){
        e.preventDefault();
        document.getElementById(e.currentTarget.getAttribute("data-imageInput")).click();
      });

      var preview = document.createElement("div");
      preview.classList.add("imagePreviewHolder");
      if(f.getAttribute("data-multiple")){
        preview.classList.add("multiple");
      }


      f.append(input);
      f.append(button);
      f.append(preview);

      if(helpText){
        var helpDiv = document.createElement("div");
        helpDiv.classList.add("helpText");
        helpDiv.innerHTML = "<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><title>Information Circle</title><path d='M248 64C146.39 64 64 146.39 64 248s82.39 184 184 184 184-82.39 184-184S349.61 64 248 64z' fill='none' stroke='currentColor' stroke-miterlimit='10' stroke-width='32'/><path fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='32' d='M220 220h32v116'/><path fill='none' stroke='currentColor' stroke-linecap='round' stroke-miterlimit='10' stroke-width='32' d='M208 340h88'/><path d='M248 130a26 26 0 1026 26 26 26 0 00-26-26z'/></svg> "+helpText;
        f.append(helpDiv);
      }


  }
};

cmsForm2022.prototype.uploadImage = async function(e,field){


  var uploadImageSingle = async (file,finalResolve) => {

    var validTypes = field.getAttribute("data-type") || "image/png,image/jpeg,image/jpg,image/gif,image/webp";
    validTypes = validTypes.split(",");
    if(!validTypes.includes(file.type)){
      alert("Invalid File Type");
      finalResolve(false);
      return false;
    }




    /*
    var imageEl = field.querySelector("img");
    if(imageEl){
      imageEl.remove();
    }
    */

    var data = new FormData();

    var imageWidth = field.getAttribute("data-width");
    var imageHeight = field.getAttribute("data-height");

    var mobileWidth = field.getAttribute("data-mobileWidth");
    var mobileHeight = field.getAttribute("data-mobileHeight");

    var maxHeight = field.getAttribute("data-maxHeight");
    var maxWidth = field.getAttribute("data-maxWidth");

    if(imageWidth && imageHeight){
      data.append("width",imageWidth);
      data.append("height",imageHeight);
    }

    var canvas = document.createElement("canvas");
    var context = canvas.getContext('2d');




    if(mobileWidth && mobileHeight){
      data.append("mobileWidth",mobileWidth);
      data.append("mobileHeight",mobileHeight);
    }

      var existingCanvas = field.querySelector("canvas");
      if(existingCanvas){
        existingCanvas.remove();
      }
      await new Promise(async (resolve,reject)=>{


        var image = new Image;
        image.onload = () => {
          var width = image.width;
          var height = image.height;
          if(maxHeight || maxWidth){

            if(maxHeight && image.height > maxHeight){
               height = maxHeight;
              var ratio = maxHeight/image.height;
               width = image.width *ratio;

            }
            else if(maxWidth && image.width > maxWidth){
               width = maxWidth;
              var ratio = maxWidth/image.width;
               height = image.height*ratio;
            }
          }
          canvas.width = width;
          canvas.height = height;

          context.drawImage(image,0,0,image.width,image.height,0,0,width,height);
          console.log("DRAWING IMAGE");
          canvas.toBlob((b)=>{

            data.append('file',b,'photo'+(1999+Math.floor(Math.random() * 999999999))+"_"+new Date().getTime()+'.png');
            resolve(true);
          });


          //field.append(canvas);

        };
        var fileData = file;
        /*
        if(file.type == "image/heic"){
          fileData = await heic2any({
                  blob: fileData,
                  toType: 'image/jpeg',
                  quality: 1,
              });
        }*/

        image.src = URL.createObjectURL(file);
      });







    fetch(field.getAttribute("data-url"), {
      method: 'POST',
      body: data
    }).then(res=>res.json())
    .then(data=>{
      if(data.imageUrl){
          var imagePreview = document.createElement("div");
          imagePreview.classList.add("imagePreview");
          imagePreview.setAttribute("data-image",data.imageUrl);
          var imagePreviewRemove = document.createElement("div");
          imagePreviewRemove.innerHTML = "&times;";
          imagePreviewRemove.classList.add("remove");
          imagePreviewRemove.setAttribute("data-image",data.imageUrl);

          imagePreviewRemove.addEventListener("click",(e)=>{
            e.preventDefault();
            var imageURL = e.currentTarget.getAttribute("data-image");

            var imageInput = e.currentTarget.parentNode.parentNode.parentNode.querySelector("input[type='hidden']");
            var imageValues = imageInput.value.split(",");
            var newValues = imageValues.filter(i=>{
              if(i == imageURL){
                return false;
              }
              return true;
            });


            imageInput.value = newValues.join(",");

            e.target.parentNode.remove();
          });

          imagePreview.append(imagePreviewRemove);

          var imagePreviewIMG = new Image();
          imagePreviewIMG.onload = () => {
            imagePreview.append(imagePreviewIMG);

            field.querySelector(".imagePreviewHolder").append(imagePreview);

          };
          imagePreviewIMG.src = data.imageUrl;




          finalResolve(data.imageUrl);
      }
      else{
        finalResolve(false);
      }


    });
  }


    var submitButton = this.form.querySelector("button[type='submit']");
    if(submitButton){
      submitButton.disabled = true;
    }

    var button = field.querySelector("button");
    button.innerHTML = "Uploading...";
    button.disabled = true;

    var loader = document.createElement("div");
    loader.classList.add("imageUploadLoading");
    var loaderSpan = document.createElement("span");
    loader.append(loaderSpan);
    field.append(loader);

    if(!field.getAttribute("data-multiple")){
      var imageInput = field.querySelector("input[type='hidden']");
      imageInput.value = "";
      field.querySelector(".imagePreviewHolder").innerHTML = "";


    }

    var promiseArray = [];
    for(let i = 0;i < e.target.files.length;i++){
      var f = e.target.files[i];
      promiseArray.push(new Promise((resolve,reject)=>uploadImageSingle(f,resolve)));

    }

    Promise.all(promiseArray).then(images=>{
      button.disabled = false;
      loader.remove();
      if(submitButton){
        submitButton.disabled = false;
      }
      var imageInput = field.querySelector("input[type='hidden']");
      if(imageInput.value && imageInput.value !== ""){
        var prevValue = imageInput.value.split(",");
        images = [...prevValue,...images];
      }

      imageInput.value = images.join(",");

      button.innerHTML = "<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><title>Cloud Upload</title><path d='M320 367.79h76c55 0 100-29.21 100-83.6s-53-81.47-96-83.6c-8.89-85.06-71-136.8-144-136.8-69 0-113.44 45.79-128 91.2-60 5.7-112 43.88-112 106.4s54 106.4 120 106.4h56' fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='32'/><path fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='32' d='M320 255.79l-64-64-64 64M256 448.21V207.79'/></svg> "+(field.getAttribute("data-button")||"Upload Photo");
    });




};
